export function notForPreview(target, key, descriptor) {
  const originMethod = target[key];

  return {
    ...descriptor,
    value() {
      const { openPreviewPrompt } = this.props;
      const editMode = _.get(this.props, 'appSettings.editMode');

      if (editMode === 'preview') {
        openPreviewPrompt();
        return null;
      }

      return originMethod.apply(this, arguments);
    },
  };
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/not-for-preview.js